import { CustomerSuccess } from './CustomerSuccess';
export default CustomerSuccess;
